import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetPassword } from './slice'
import {
  selectForgotPasswordFormData,
  changeEmail,
  changeRequestStatus,
  selectError,
  selectRequestStatus,
} from '../../../reducers/user/forgot-password-form'
import { REQUEST_STATUSES } from '../../../reducers/reducer-helper'
import { Link } from 'react-router-dom'
import NotificationPopup from '../../common/notification-popup/NotificationPopup'
import Loader from '../../common/loader/Loader'

function EmailForm() {
  const dispatch = useDispatch()

  const formData = useSelector(selectForgotPasswordFormData)
  const error = useSelector(selectError)
  const requestStatus = useSelector(selectRequestStatus)

  const changeEmailProcess = (event) => {
    event.preventDefault()
    dispatch(changeEmail({ email: event.target.value }))
  }

  const resetPasswordProcess = (event) => {
    event.preventDefault()
    dispatch(changeRequestStatus({ status: REQUEST_STATUSES.PENDING }))
    dispatch(resetPassword({ email: formData.email }))
  }

  return (
    <>
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Forgot account</h2>
        <div className="mt-4 text-center text-sm text-gray-500">Please provide your email to proceed</div>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6">
          {error && <NotificationPopup message={error.message} />}
          <div>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Email address"
                value={formData.email}
                onChange={(e) => changeEmailProcess(e)}
                autoComplete="email"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              type="button"
              disabled={requestStatus === REQUEST_STATUSES.PENDING}
              onClick={resetPasswordProcess}
              className={`flex w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
            >
              {requestStatus === REQUEST_STATUSES.PENDING && <Loader />}
              <span>Continue</span>
            </button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm text-gray-500">
          Remember your password?{' '}
          <Link to="/sign-in" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
            Sign In
          </Link>
        </p>
      </div>
    </>
  )
}

export default memo(EmailForm)
